import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./Use_Current_Location.css";
import Your_Location_modal from "../Your_Location_modal/Your_Location_modal";
import Green_Btn from "../../common_btn/green_btn/Green_Btn";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentLocation } from "../../../../features/location/locationSlice";

function Use_Current_Location(props) {
  const [locationText, setLocationText] = useState("Use Current Location");
  const [isLoading, setIsLoading] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false); // State for the "Type manually" modal

  // const handleUseCurrentLocation = () => {
  //   setLocationText("Fetching your location...");
  //   setIsLoading(true);

  //   // Use the Geolocation API to get the current location
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
         
  //         console.log(position.coords);

  //         // Set a timeout to close the modal after 3 seconds
  //         setTimeout(() => {
  //           props.onHide(); // Close the modal
  //         }, 3000);

  //         setIsLoading(false);
  //       },
  //       (error) => {
  //         console.error(error);
  //         setLocationText("Failed to get location");
  //         setIsLoading(false);
  //       }
  //     );
  //   } else {
  //     setLocationText("Geolocation is not supported by this browser.");
  //     setIsLoading(false);
  //   }
  // };

  const handleShowLocationModal = () => {
    setShowLocationModal(true); // Show the "Type manually" modal
    props.onHide();
  };

  const handleCloseLocationModal = () => {
    setShowLocationModal(false); // Close the "Type manually" modal
  };

   const handleOpenLocationModal = () => {
    setShowLocationModal(true); // Close the "Type manually" modal
  };

  // const [locationText, setLocationText] = useState("Use Current Location");
  // const [isLoading, setIsLoading] = useState(false);
  // const [showLocationModal, setShowLocationModal] = useState(false); // State for the "Type manually" modal

  const current_location = useSelector((state) => state.location.current_location);

  const dispatch = useDispatch();

 

  const handleUseCurrentLocation = async () => {
    setLocationText("Fetching your location...");
    setIsLoading(true);

    try {
      const res = await dispatch(getCurrentLocation());
      if (res.meta.requestStatus === "fulfilled") {
        setLocationText("Location fetched");
        setTimeout(() => { props.onHide() }, 3000);
      } else if (res.meta.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Failed to fetch location");
        setLocationText("Failed to get location");
      }
    } catch (error) {
      console.error("Error in location fetch:", error);
      setLocationText("An unexpected error occurred.");
    } finally {
      setIsLoading(false);
    }
  };


  // const handleShowLocationModal = () => {
  //   setShowLocationModal(true);
  //   props.onHide();
  // };

  // const handleCloseLocationModal = () => {
  //   setShowLocationModal(false);
  // };

  return (
    <>
      <section className="Use_Current_Location">
        <Modal
          {...props}
          size="md"
          centered
          className="Use_Current_Location modal-holder"
          // backdrop="static"
        >
          <Modal.Body>
            <div className="address-text-holder">
              <div className="icon-holder">
                <img
                  className="icon-img"
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/icons/green_location.png"
                  }
                  alt="Location Icon"
                />
              </div>
              <div className="text-holder">
                <p>
                  To get quick delivery, we would like to ensure your current location
                </p>
              </div>
            </div>

            <div className="footer-btn-holder">
              <div className="text-center btn_holder">
                <Green_Btn btn_name="Type manually" onClick={handleShowLocationModal} />
                {/* <Button
                  className="submit-btn "
                  type="button"
                  onClick={handleShowLocationModal} // Open the "Type manually" modal
                >
                  Type manually
                </Button> */}
              </div>

              <div className="text-center btn_holder">
                <Button
                  className="use-btn "
                  type="button"
                  onClick={handleUseCurrentLocation}
                  disabled={isLoading} // Disable the button while loading
                >
                  {locationText}
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Your Location Modal */}
        <Your_Location_modal
          show={showLocationModal}
          onHide={handleCloseLocationModal} 
          onOpen={handleOpenLocationModal} 
          onBackToChooseLocation={handleCloseLocationModal}
          onOpenYourLocation={handleCloseLocationModal}
          setShowConfimLocModal={props?.setShowConfimLocModal}
        />
      </section>
    </>
  );
}

export default Use_Current_Location;
